<header class="d-flex justify-content-end p-4">
    <div class="lang" *ngFor="let lang of langs" (click)="changeLang(lang.cod)">{{lang.name}}</div>
</header>
